module.exports = __webpack_public_path__ + "img/1362789219.fff285b9.jpg";